import { connect } from 'react-redux';

import { redeemGift } from '../../redemption.actions';

import PlatformFirstPlatformSelection from './platform-first-platform-selection.component';
import { IRedeemCodeData } from 'types/redemption';
import { Dispatch } from 'types/dispatch';
import {
    IPlatformFirstPlatformSelectionDispatchProps,
    IPlatformFirstPlatformSelectionStoreProps
} from './platform-first-platform-selection.types';
import { sortByOrder } from 'utils/array';
import { IProfilePlatforms } from 'types/profiles';
import { PLATFORMS_ORDER } from 'constants/platform';

/* We suppress the error here because we have not yet there interface for the store */
// @ts-ignore
const mapStateToProps = (state): IPlatformFirstPlatformSelectionStoreProps => {
    return {
        fetching: state.redemption?.fetching ?? null,
        preselectedPlatformId: state.redemption?.redeemData?.platform ?? null,
        profilePlatforms: sortByOrder(
            (state.login?.loginSession?.UbisoftConnectProfiles ?? []) as IProfilePlatforms,
            PLATFORMS_ORDER, 'id'
        ),
        codeFormat: state.config.RSCodeFormat
    };
};

const mapDispatchToProps = (dispatch: Dispatch): IPlatformFirstPlatformSelectionDispatchProps => ({
    redeemGift: (redeemData: IRedeemCodeData): void => {
        dispatch(redeemGift(redeemData));
    }
});

const PlatformFirstfPlatformSelectionContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PlatformFirstPlatformSelection);

export default PlatformFirstfPlatformSelectionContainer;
